import React from 'react';
import PropTypes from 'prop-types';
import Instrument from './Instrument';

const Instruments = ({
  instruments,
  order,
  style,
  reorderInstruments,
  resizeInstrument,
  popoutInstrument,
  isHorizontal,
  isLargeScreen,
  isPopoutMode,
  isSimulateMode,
  preconfiguredSet,
  updateNoScrollMinHeight,
  setReorderingSize,
  scrollContainerRef,
  hasInstrumentOptions,
}) => {
  const instrumentLength = instruments.length;
  const orderMap = Object.entries(order).reduce((orderObj, [idx, name]) => {
    orderObj[name] = parseInt(idx);
    return orderObj;
  }, {});
  return (
    <>
      {instruments.map((instrument) => {
        const {name, size} = instrument;
        const _order = orderMap[name];
        const originalLeft = !isHorizontal
          ? 0
          : size === 'large'
          ? order.slice(0, _order).reduce((sum, name) => sum + style.width[name], 0)
          : _order * style.width;
        const originalTop = isHorizontal
          ? 0
          : order.slice(0, _order).reduce((sum, name) => sum + style.height[name], 0);
        const handlePopoutInstrument = (settingsJson) => {
          const newInstrument = {
            ...instrument,
            settings: settingsJson,
          };
          popoutInstrument({instrument: newInstrument});
        };
        return (
          <Instrument
            key={name}
            order={_order}
            originalLeft={originalLeft}
            originalTop={originalTop}
            instrumentLength={instrumentLength}
            instrument={instrument}
            style={
              size === 'large'
                ? {...style, width: style.width[name], height: style.height[name]}
                : {...style, height: style.height[name]}
            }
            reorderInstruments={reorderInstruments}
            resizeInstrument={resizeInstrument}
            popoutInstrument={handlePopoutInstrument}
            isHorizontal={isHorizontal}
            isLargeScreen={isLargeScreen}
            isPopoutMode={isPopoutMode}
            isSimulateMode = {isSimulateMode}
            preconfigured={preconfiguredSet.has(name)}
            updateNoScrollMinHeight={updateNoScrollMinHeight}
            setReorderingSize={setReorderingSize}
            scrollContainerRef={scrollContainerRef}
            hasInstrumentOptions={hasInstrumentOptions}
          />
        );
      })}
    </>
  );
};

Instruments.propTypes = {
  instruments: PropTypes.array.isRequired,
  order: PropTypes.array.isRequired,
  style: PropTypes.object.isRequired,
  reorderInstruments: PropTypes.func.isRequired,
  resizeInstrument: PropTypes.func.isRequired,
  popoutInstrument: PropTypes.func.isRequired,
  isHorizontal: PropTypes.bool.isRequired,
  isLargeScreen: PropTypes.bool.isRequired,
  isPopoutMode: PropTypes.bool.isRequired,
  isSimulateMode: PropTypes.bool.isRequired,
  preconfiguredSet: PropTypes.object.isRequired,
  updateNoScrollMinHeight: PropTypes.func.isRequired,
  setReorderingSize: PropTypes.func.isRequired,
  scrollContainerRef: PropTypes.object,
  hasInstrumentOptions: PropTypes.bool.isRequired,
};

Instruments.defaultProps = {
  isHorizontal: false,
  isPopoutMode: false,
};

export default Instruments;
